import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCartItems,
  selectCartTotal,
  removeFromCart,
  updateQty,
} from "../redux/slice/CartSlice";
import noimage from "../image/noimage.jpg";

export default function MiniCart() {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const items     = useSelector(selectCartItems);
  const total     = useSelector(selectCartTotal);
  const shipping  = total >= 999 ? 0 : (items.length > 0 ? 99 : 0);
  const grandTotal = total + shipping;

  const closeOffcanvas = () => {
    const el = document.getElementById("miniCartOffcanvas");
    const bsOffcanvas = window.bootstrap?.Offcanvas?.getInstance(el);
    bsOffcanvas?.hide();
  };

  const handleCheckout = () => {
    closeOffcanvas();
    navigate("/checkout");
  };

  return (
    <div
      className="offcanvas offcanvas-end mg-minicart"
      tabIndex="-1"
      id="miniCartOffcanvas"
      aria-labelledby="miniCartLabel"
    >
      {/* Header */}
      <div className="mg-minicart-header">
        <h5 id="miniCartLabel">
          <i className="fas fa-shopping-cart me-2"></i>
          Your Cart
          {items.length > 0 && (
            <span className="mg-minicart-count">{items.reduce((s, i) => s + i.qty, 0)}</span>
          )}
        </h5>
        <button
          type="button"
          className="mg-minicart-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <i className="fas fa-times"></i>
        </button>
      </div>

      {/* Body */}
      <div className="mg-minicart-body">
        {items.length === 0 ? (
          <div className="mg-minicart-empty">
            <i className="fas fa-shopping-bag"></i>
            <p>Your cart is empty</p>
            <Link
              to="/shop"
              className="mg-minicart-shop-btn"
              onClick={closeOffcanvas}
            >
              Start Shopping
            </Link>
          </div>
        ) : (
          <div className="mg-minicart-items">
            {items.map((item) => (
              <div className="mg-minicart-item" key={item.key}>
                <div className="mg-minicart-img">
                  <img
                    src={item.image || noimage}
                    alt={item.title}
                    onError={(e) => { e.target.src = noimage; }}
                  />
                </div>
                <div className="mg-minicart-meta">
                  <p className="mg-minicart-title">{item.title}</p>
                  {item.variantInfo && (
                    <span className="mg-minicart-variant">{item.variantInfo}</span>
                  )}
                  <div className="mg-minicart-price-row">
                    <span className="mg-minicart-price">
                      ₹{(item.price * item.qty).toLocaleString("en-IN")}
                    </span>
                    <div className="mg-qty-stepper">
                      <button
                        onClick={() => dispatch(updateQty({ key: item.key, qty: item.qty - 1 }))}
                        aria-label="Decrease quantity"
                      >−</button>
                      <span>{item.qty}</span>
                      <button
                        onClick={() => dispatch(updateQty({ key: item.key, qty: item.qty + 1 }))}
                        aria-label="Increase quantity"
                      >+</button>
                    </div>
                  </div>
                </div>
                <button
                  className="mg-minicart-remove"
                  onClick={() => dispatch(removeFromCart(item.key))}
                  aria-label="Remove item"
                >
                  <i className="fas fa-trash-alt"></i>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      {items.length > 0 && (
        <div className="mg-minicart-footer">
          <div className="mg-minicart-subtotal">
            <span>Subtotal</span>
            <span>₹{total.toLocaleString("en-IN")}</span>
          </div>
          <div className="mg-minicart-subtotal">
            <span>Shipping</span>
            <span className={shipping === 0 ? "text-success fw-bold" : ""}>
              {shipping === 0 ? "FREE" : `₹${shipping}`}
            </span>
          </div>
          {shipping > 0 && (
            <p className="mg-free-shipping-note">
              Add ₹{(999 - total).toLocaleString("en-IN")} more for FREE shipping
            </p>
          )}
          <div className="mg-minicart-total">
            <span>Total</span>
            <span>₹{grandTotal.toLocaleString("en-IN")}</span>
          </div>
          <button
            className="mg-minicart-checkout-btn"
            onClick={handleCheckout}
          >
            Proceed to Checkout
            <i className="fas fa-arrow-right ms-2"></i>
          </button>
          <Link
            to="/cart"
            className="mg-minicart-view-cart"
            onClick={closeOffcanvas}
          >
            View Full Cart
          </Link>
        </div>
      )}
    </div>
  );
}
